import React, { useState } from "react";
import "./MyProfile.css";

const MyProfile = ({ user, setSidebarPage }) => {  const [open, setOpen] = useState({
    basic: false,
    contact: false,
    education: false,
    places: false,
    services: false,
    tags: false,
  });

  const toggle = (key) => {
    setOpen({ ...open, [key]: !open[key] });
  };

  if (!user) return <p>Loading...</p>;

  return (
    <div className="myprofile-wrapper">

      {/* TOP SECTION */}
     <div className="profile-header">
  {/* LEFT: Profile photo */}
  <div className="profile-photo"></div>

  {/* RIGHT: Username + Edit button */}
  <div className="profile-right">
    <h2 className="profile-name">{user.fullName}</h2>
    <p className="profile-username">@{user.instagramUsername || "username"}</p>
    <button 
      className="edit-profile-btn"
      onClick={() => setSidebarPage("profile")}
    >
      Edit Profile
    </button>
  </div>

  {/* BELOW PHOTO: Status */}
  <p className="profile-status">{user.status || ""}</p>

  {/* BELOW STATUS: Followers / Following / My Level */}
  <div className="follow-row">
    <div>
      <h3>1</h3>
      <p>Followers</p>
    </div>
    <div>
      <h3>1</h3>
      <p>Following</p>
    </div>
    <div>
      <h3>1</h3>
      <p>My Level</p>
    </div>
  </div>
</div>


      {/* ABOUT SECTION TITLE */}
      <h3 className="about-title">About</h3>

      {/* EXPANDABLE SECTIONS */}
      <div className="about-card">

        {/* BASIC INFO */}
        <div className="section">
          <div className="section-head" onClick={() => toggle("basic")}>
            <h4>Basic Information</h4>
            <span>{open.basic ? "-" : "+"}</span>
          </div>

          {open.basic && (
            <div className="section-body">
              <p><strong>Gender:</strong> {user.gender}</p>
              <p><strong>DOB:</strong> {user.dob?.slice(0, 10)}</p>
              <p><strong>Marital Status:</strong> {user.maritalStatus}</p>
              <p><strong>Interested In:</strong> {user.interestedIn?.join(", ")}</p>
              <p><strong>Languages:</strong> {user.languages?.join(", ")}</p>
              <p><strong>Religion:</strong> {user.religion}</p>
               <p><strong>Have Pets:</strong> {user.pets ? "Yes" : "No"}</p>
    <p><strong>Smoke:</strong> {user.smoke ? "Yes" : "No"}</p>
    <p><strong>Drink:</strong> {user.drink ? "Yes" : "No"}</p>
            </div>
          )}
        </div>

        {/* CONTACT INFO */}
        <div className="section">
          <div className="section-head" onClick={() => toggle("contact")}>
            <h4>Contact Information</h4>
            <span>{open.contact ? "-" : "+"}</span>
          </div>

          {open.contact && (
            <div className="section-body">
              <p><strong>Email:</strong> {user.email}</p>
              <p><strong>Mobile:</strong> {user.mobile}</p>
              <p><strong>Address:</strong> {user.address}</p>
              <p><strong>Aadhar:</strong> {user.aadhar}</p>
            </div>
          )}
        </div>

        {/* EDUCATION */}
        <div className="section">
          <div className="section-head" onClick={() => toggle("education")}>
            <h4>Education</h4>
            <span>{open.education ? "-" : "+"}</span>
          </div>

          {open.education && (
            <div className="section-body">
              <p><strong>High School:</strong> {user.highSchool}</p>
              <p><strong>Diploma:</strong> {user.diploma}</p>
              <p><strong>Graduation:</strong> {user.graduation}</p>
            </div>
          )}
        </div>

        {/* PLACES */}
        <div className="section">
          <div className="section-head" onClick={() => toggle("places")}>
            <h4>Places</h4>
            <span>{open.places ? "-" : "+"}</span>
          </div>

          {open.places && (
            <div className="section-body">
              <p><strong>Lives In:</strong> {user.livesIn}</p>
              <p><strong>From:</strong> {user.from}</p>
              <p><strong>Current Location:</strong> {user.currentLocation}</p>
            </div>
          )}
        </div>

        {/* SERVICES */}
        <div className="section">
          <div className="section-head" onClick={() => toggle("services")}>
            <h4>Services</h4>
            <span>{open.services ? "-" : "+"}</span>
          </div>

          {open.services && (
            <div className="section-body">
              <p><strong>Want to Donate Blood:</strong> {user.donateBlood ? "Yes" : "No"}</p>
              <p><strong>Want to Help People:</strong> {user.helpPeople ? "Yes" : "No"}</p>
              <p><strong>Volunteer for Community Service:</strong> {user.volunteer ? "Yes" : "No"}</p>
            </div>
          )}
        </div>

        {/* PUBLIC TAGS */}
{/* PUBLIC TAGS */}
<div className="section">
  <div className="section-head" onClick={() => toggle("tags")}>
    <h4>Public Tags</h4>
    <span>{open.tags ? "-" : "+"}</span>
  </div>

  {open.tags && (
    <div className="section-body">

      {user.blogger && <p>Blogger</p>}
      {user.entrepreneur && <p>Entrepreneur</p>}
      {user.traveller && <p>Traveller</p>}

      {/* Show message if nothing selected */}
      {!user.blogger &&
       !user.entrepreneur &&
       !user.traveller && (
        <p>No public tags selected</p>
      )}

    </div>
  )}
</div>


      </div>
    </div>
  );
};

export default MyProfile;
